import { render } from "./ConsultaFichaEpisLegado.vue?vue&type=template&id=cc5429e6"
import script from "./ConsultaFichaEpisLegado.vue?vue&type=script&lang=js"
export * from "./ConsultaFichaEpisLegado.vue?vue&type=script&lang=js"

import "./ConsultaFichaEpisLegado.vue?vue&type=style&index=0&id=cc5429e6&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QInput,QBtn,QTable,QImg,QTd,QPagination,QField});
